<template>
    <div class="col-12 px-0 py-2 info-message" v-bind:class="{'first': isFirst}">
        <p class="font-weight-bold" v-html="title"></p>
        <p class="my-0" v-html="body"></p>
    </div>
</template>

<script>
    export default {
        name: "InfoMessage",

        props: {
            title: String,
            body: String,
            index: Number
        },

        computed: {
            isFirst: function() {
                return this.index === 0;
            }
        }
    }
</script>

<style scoped>
    .info-message {
        border-top: 2px solid var(--account-row-border-color);
    }

    .info-message.first {
        border-top: none;
    }
</style>